import React, { Fragment } from 'react';
import { HeaderOneRow } from '@cotyorg/ccx-organism-header';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Cookie } from '@cotyorg/ccx-organism-cookie';
import { FooterStreamlined } from '@cotyorg/ccx-organism-footer';

const Placeholder = ({
  cookieContent,
  searchLink,
}) => (
  <Fragment>
    <Helmet><title>Placeholder</title></Helmet>
    <HeaderOneRow
      search
      searchLink={searchLink}
      basket
      logoSrc="/assets/logo-alt.svg"
      logoPosition="left"
    />

    <div className="page__heading">
      <h1 className="heading">Placeholder</h1>
    </div>

    <div>Replace with page component, coming from brand site.</div>

    <FooterStreamlined
      showCountrySelector
    />

    <Cookie
      position="bottom"
      content={cookieContent}
      closeIconSrc="/assets/close.svg"
    />
  </Fragment>
);

Placeholder.propTypes = {
  cookieContent: PropTypes.objectOf(PropTypes.any).isRequired,
  searchLink: PropTypes.string.isRequired,
};

export default connect(
  state => ({
    cookieContent: state.content.cookie,
    searchLink: state.content.navigation.searchLink,
  }),
)(Placeholder);
